import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
// import md5 from 'crypto-js/md5';
// import aes from 'crypto-js/aes';
// import NodeRSA from 'node-rsa';
// import api from '../api';
import api from '../api/retry';
import chatStore from './chatStore';

const tokenTimeout = 4000; // 重新获取token查询时间限制

// 设置公钥
// const pem = `-----BEGIN PUBLIC KEY-----
// MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDJuYYs3NoRMLVBCPqpROHu3K5V
// 50ZxluIPC6I13vl0vuu1XuAt88gpC5zERI9x8KSzzhHRKAKmbvTCKHDTJINwCfvu
// OhzjxUPNxWvLVF1aioIVsdmAqpkYsislydtOSB8VNT0sELDbHRWS5+6USYs92hLy
// 1/mK/AATLsvKR0KmlQIDAQAB
// -----END PUBLIC KEY-----`;

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    authInfo: {
      access_token: '',
      agentId: '',
      appkey: '',
      appsecret: '',
      corpId: '',
      jsapi_ticket: '',
      signature: '',
      timeStamp: 0,
      nonceStr: '',
      name: '',
      ticket_expired_time: '',
      token_expired_time: ''
    },
    ConfigList: [], // 配置权限列表
    authToken: '',
    reSet: false,
    tabs: [] // 记录tab位置
  },
  modules: {
    chatStore
  },
  mutations: {
    updateKeepAliveInclude: (state, data) => {
      state.keepAliveInclude = data;
    },
    clearKeepAliveInclude: state => {
      state.keepAliveInclude = [];
    },
    updateConfig: (state, data) => {
      state.ConfigList = data;
    },
    updateAuthInfo: (state, data) => {
      state.authInfo = data;
    },
    updateAuthToken: (state, data) => {
      state.authToken = data;
    },
    SAVE_TABS: (state, { path, tab }) => {
      let find = false;
      state.tabs.map(p => {
        if (p.path === path) {
          p.tab = tab;
          find = true;
        }
      });
      if (!find) {
        state.tabs.push({
          path: path,
          tab: tab
        });
      }
    }
  },
  actions: {
    async postData({dispatch, commit, state}, {url, data, needSign = true, time = 0}) {
      try {
        // if (typeof data === 'object' && process.env.VUE_APP_ENABLE_SIGN && needSign) {
        //   const sign = md5(JSON.stringify(data));
        //   // data.sign = aes.encrypt(sign.toString(), url.replace('/api', '')).toString();
        //   data.S = aes.encrypt(sign.toString().toUpperCase(), url).toString();
        // }
        const res = await api.post(url, data);
        if (res) {
          switch (res.code) {
            case 0:
              return res.data;
              break;
            case 401: // 401 token过期
            case 10110002: // 10110002 token过期已刷新过
              if (time <=2) {
                const getToken = new Promise((resolve, reject) => {
                  // 调用app壳功能重新获取token,然后重新发送
                  // eslint-disable-next-line
                  uni.webView.postMessage({
                    data: {
                      action: 'resetToken',
                      data: {
                        success: 'resetToken', // 成功回调方法名success(res接口返回序列化字符串)
                        authToken: state.authToken, // 现有authToken
                        error: 'TokenErr' // 失败回调方法名error(msg<报错信息字符串>)
                      }
                    }
                  });
                  // 等待重置token,超时取消请求抛出错误
                  const timeout = setTimeout(() => {
                    window.resetToken = '';
                    window.TokenErr = '';
                    reject(new Error('亲，网络似乎出了点问题ㄟ( ▔, ▔ )ㄏ'));
                  }, tokenTimeout);
                  window.TokenErr = function(message) {
                    window.resetToken = '';
                    window.TokenErr = '';
                    clearTimeout(timeout);
                    reject(new Error(message));
                  }
                  window.resetToken = function(token) {
                    try {
                      window.resetToken = '';
                      window.TokenErr = '';
                      clearTimeout(timeout);
                      resolve(token);
                    } catch (error) {
                      clearTimeout(timeout);
                      reject(error);
                    }
                  }
                });
                const token = await getToken;
                commit('updateAuthToken', token);
                return dispatch('postData', {url: url, data: data, needSign: needSign, time: time + 1}, { root: true});
              } else {
                throw new Error(res.msg);
              }
              break;
            case 10110005:
            case 10110006:
              uni.webView.postMessage({
                data: {
                  action: 'reLogin'
                }
              });
              throw new Error('登录异常');
              break;
            default:
              throw new Error(res.msg);
              break;
          }
        }
      } catch (error) {
        if (error.message.includes('登录异常')) {
          throw error;
        }
        if (time <2 && (error.message.includes('亲，网络'))) {
          return dispatch('postData', {url: url, data: data, needSign: needSign, time: time + 1}, { root: true});
        }
        throw error;
      }
    },
    async getData({dispatch, commit, state}, {url, data, needSign = true, time = 0}) {
      try {
        // if (typeof data === 'object' && process.env.VUE_APP_ENABLE_SIGN && needSign) {
        //   const sign = md5(JSON.stringify(data));
        //   data.S = aes.encrypt(sign.toString().toUpperCase(), url).toString();
        // }
        const res = await api.get(url, data);
        
        if (res) {
          switch (res.code) {
            case 0:
              return res.data;
              break;
            case 401: // 401 token过期
            case 10110002: // 10110002 token过期已刷新过
              if (time <=2) {
                const getToken = new Promise((resolve, reject) => {
                  // 调用app壳功能重新获取token,然后重新发送
                  // eslint-disable-next-line
                  uni.webView.postMessage({
                    data: {
                      action: 'resetToken',
                      data: {
                        success: 'resetToken', // 成功回调方法名success(res接口返回序列化字符串)
                        authToken: state.authToken, // 现有authToken
                        error: 'TokenErr' // 失败回调方法名error(msg<报错信息字符串>)
                      }
                    }
                  });
                  // 等待重置token,超时取消请求抛出错误
                  const timeout = setTimeout(() => {
                    window.resetToken = '';
                    window.TokenErr = '';
                    reject(new Error('亲，网络似乎出了点问题ㄟ( ▔, ▔ )ㄏ'));
                  }, tokenTimeout);
                  window.TokenErr = function(message) {
                    window.resetToken = '';
                    window.TokenErr = '';
                    clearTimeout(timeout);
                    reject(new Error(message));
                  }
                  window.resetToken = function(token) {
                    try {
                      window.resetToken = '';
                      window.TokenErr = '';
                      clearTimeout(timeout);
                      resolve(token);
                    } catch (error) {
                      clearTimeout(timeout);
                      reject(error);
                    }
                  }
                });
                const token = await getToken;
                commit('updateAuthToken', token);
                return dispatch('getData', {url: url, data: data, needSign: needSign, time: time + 1}, { root: true});
              } else {
                throw new Error(res.msg);
              }
              break;
            case 10110005:
            case 10110006:
              uni.webView.postMessage({
                data: {
                  action: 'reLogin'
                }
              });
              throw new Error('登录异常');
              break;
            default:
              throw new Error(res.msg);
              break;
          }
        }
      } catch (error) {
        if (error.message.includes('登录异常')) {
          throw error;
        }
        if (time <2 && error.message.includes('亲，网络')) {
          return dispatch('getData', {url: url, data: data, needSign: needSign, time: time + 1}, { root: true});
        }
        throw error;
      }
    },
    saveTabs: ({ commit }, { path, tab }) => {
      commit('SAVE_TABS', { path, tab });
    },
    async setStorage({}, {name, message}) {
      try {
        if (navigator.userAgent.indexOf('uni-app') > -1) {
          // eslint-disable-next-line
          uni.webView.postMessage({
            data: {
              action: 'SetInfo',
              data: {
                name,
                message: JSON.stringify(message), // message<信息序列号字符串>
                error: 'Toast' // 失败回调方法名error(msg<报错信息字符串>)
              }
            }
          });
        } else {
          localStorage.setItem(name, JSON.stringify(message));
        }
      } catch (error) {
        throw error;
      }
    },
    async getStorage({}, {name}) {
      try {
        if (navigator.userAgent.indexOf('uni-app') > -1) {
          const GetInfo = new Promise((resolve, reject) => {
            // eslint-disable-next-line
            uni.webView.postMessage({
              data: {
                action: 'GetInfo',
                data: {
                  name, // 存储字段名
                  success: 'getInfo', // 成功回调方法名success(message<信息序列号字符串>)
                  error: 'getErr' // 失败回调方法名error(msg<报错信息字符串>)
                }
              }
            });
            const timeout = setTimeout(() => {
              window.getInfo = '';
              window.getErr = '';
              reject(new Error('获取本地存储失败'));
            }, 1500);
            window.getErr = function(message) {
              window.getInfon = '';
              window.getErr = '';
              clearTimeout(timeout);
              reject(new Error(message));
            }
            window.getInfo = function(json) {
              try {
                window.getInfo = '';
                window.getErr = '';
                json = json ? JSON.parse(json) : {};
                clearTimeout(timeout);
                resolve(json);
              } catch (error) {
                clearTimeout(timeout);
                reject(error);
              }
            }
          });
          const res = await GetInfo;
          return res;
        } else {
          const info = localStorage.getItem(name);
          return JSON.parse(info);
        }
      } catch (error) {
        throw error;
      }
    },
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ]
});
